var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 52.9453C11.125 52.9453 9.9475 52.4561 8.9675 51.4778C7.98917 50.4978 7.5 49.3203 7.5 47.9453V12.9453C7.5 11.5703 7.98917 10.3928 8.9675 9.41281C9.9475 8.43448 11.125 7.94531 12.5 7.94531H47.5C48.875 7.94531 50.0525 8.43448 51.0325 9.41281C52.0108 10.3928 52.5 11.5703 52.5 12.9453V47.9453C52.5 49.3203 52.0108 50.4978 51.0325 51.4778C50.0525 52.4561 48.875 52.9453 47.5 52.9453H12.5ZM30 40.4453C31.3333 40.4453 32.5625 40.1011 33.6875 39.4128C34.8125 38.7261 35.7292 37.8203 36.4375 36.6953C36.6875 36.3203 37 36.0178 37.375 35.7878C37.75 35.5595 38.1667 35.4453 38.625 35.4453H47.5V12.9453H12.5V35.4453H21.375C21.8333 35.4453 22.25 35.5595 22.625 35.7878C23 36.0178 23.3125 36.3203 23.5625 36.6953C24.2708 37.8203 25.1875 38.7261 26.3125 39.4128C27.4375 40.1011 28.6667 40.4453 30 40.4453Z",
    fill: "#A3BBDC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmpty);
export default __webpack_public_path__ + "static/media/icon_empty.9cc4f91bc3303167b0265a5c983e9fdc.svg";
export { ForwardRef as ReactComponent };